import { render } from "./WhatsAppModalSidebarRightChatMessageContainer.vue?vue&type=template&id=2d6c37cf&scoped=true"
import script from "./WhatsAppModalSidebarRightChatMessageContainer.vue?vue&type=script&lang=js"
export * from "./WhatsAppModalSidebarRightChatMessageContainer.vue?vue&type=script&lang=js"

import "./WhatsAppModalSidebarRightChatMessageContainer.vue?vue&type=style&index=0&id=2d6c37cf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6c37cf"]])

export default __exports__